import { call, put, select, takeLatest } from 'redux-saga/effects'
import { setIsPatientPregnantOptions } from '../store/options.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getIsPatientPregnantOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getIsPatientPregnantOptions])
    const { entity } = response

    yield put(setIsPatientPregnantOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getIsPatientPregnantOptions() error: ${e}`))
  }
}
export function* getIsPatientPregnantOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getIsPatientPregnantOptions)
}
